import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CtAlreadyLogin } from 'containers';

// 로그인 되어있을때 로그인 제한 화면
class AlreadyLoginPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { toGo, accessLevel } = this.props;
    let mainPage = accessLevel === 2 ? '/mudmanage' : '/main';
    if (toGo) {
      mainPage = toGo;
    }

    return <CtAlreadyLogin mainPage={mainPage} accessLevel={accessLevel} />;
  }
}

export default AlreadyLoginPage;



// WEBPACK FOOTER //
// ./src/script/pages/AlreadyLoginPage.js